'use strict';

import {BaseElement} from "../../../../interfaces/BaseElement";
import {EventBus} from "../../../../interfaces/EventBus";
import {settingsData} from "../../../../../settings";
import {Filter} from "./Filter";
import { renderUpdateValuesOnDemand } from '../../../../../app';
import { searchGetResults, selectedBuildings } from '../../search';
import {FavoriteButton} from "./FavoriteButton";
import {applyShortBuildingNameRule} from "../../../../../functions";
import {ActiveFiltersCounter} from "../../ShrinkSearch/ActiveFiltersCounter";

export class SearchFilter {
	#rootElement;
	#filtersCounter;
	#filter;
	#favorite;

	constructor() {
		settingsData.searchResult = [];
		selectedBuildings.clear();

		this.#rootElement = new BaseElement()
			.addClass('mobile-search__search-filter');

		applyShortBuildingNameRule();

		// this.#chips = new SearchChips();
		this.#filter = new Filter(this.#applyFilters.bind(this));
		this.#favorite = new FavoriteButton();
		this.#filtersCounter = new ActiveFiltersCounter();

		this.#build();
	}

	get rootElement() {
		return this.#rootElement;
	}

	#build() {
		// this.#chips.rootElement.appendTo(this.#rootElement.DOMElement);
		this.#filter.rootElement.appendTo(this.#rootElement);
		this.#favorite.rootElement.appendTo(this.#rootElement);
		this.#filtersCounter.rootElement.appendTo(this.#filter.rootElement);
	}

	#applyFilters() {
		searchGetResults();
		EventBus.trigger('resultsViewerToggleContent');
		renderUpdateValuesOnDemand(false);
		// EventBus.trigger('filterUpdateFilterCount');
		EventBus.trigger('resultsViewerSlideToApartment');
		this.#filtersCounter.update();
	}

	remove() {
		// this.#chips.remove();
		// this.#chips = null;

		this.#filter.remove();
		this.#filter = null;

		this.#rootElement.remove();
		this.#rootElement = null;
	}
}
